import { render, staticRenderFns } from "./PromptEditPriceAndAmount.vue?vue&type=template&id=6b5a35d8&scoped=true&"
import script from "./PromptEditPriceAndAmount.vue?vue&type=script&lang=js&"
export * from "./PromptEditPriceAndAmount.vue?vue&type=script&lang=js&"
import style0 from "./PromptEditPriceAndAmount.vue?vue&type=style&index=0&id=6b5a35d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5a35d8",
  null
  
)

export default component.exports